import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './index.css';

import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="60370213438-oon0gd4p2p76g9uoi0ct0eji84np2ufq.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>
);